import Phaser from 'phaser';
import { audio } from './AudioSynth';
import { voice } from './Voice';

interface AchievementAnnouncement {
  id: string;
  name: string;
}

const ACHIEVEMENT_VOICE: Record<string, string> = {
  first_blood: 'achievement_first_blood',
  boss_slayer: 'achievement_boss_slayer',
  perfect_kappa: 'achievement_perfect_kappa',
  nightmare: 'achievement_nightmare',
};

/** Every achievement gets a confirmation chime and a voice line when enabled. */
export function announceAchievement(scene: Phaser.Scene, def: AchievementAnnouncement): void {
  audio.upgrade();
  voice.play(scene, ACHIEVEMENT_VOICE[def.id] ?? 'achievement_generic', {
    category: 'commendation',
    cooldown: 10,
  });
}
